export default __webpack_public_path__ + "static/media/Exec-money.a60de3af.svg";